export default __webpack_public_path__ + "static/media/train-for-ulti.67dd9684.jpg";